import accountReducer from './accountReducer';
import adminReducer from './adminReducer';
import agentReducer from './agentReducer';
import agentsPaymentReducer from './agentsPaymentReducer';
import clientReducer from './clientReducer';
import collectionReducer from './collectionReducer';
import contractReducer from './contractReducer';
import customerReducer from './customerReducer';
import detailsPanelReducer from './detailsPanelReducer';
import domiciliationPermissionsReducer from './domiciliationPermissionsReducer';
import errorsReducer from './errorsReducer';
import integrationsReducer from './integrationsReducer';
import invoiceReducer from './invoiceReducer';
import loginReducer from './loginReducer';
import notificationsReducer from './notificationsReducer';
import paymentAccountReducer from './paymentAccountReducer';
import paymentReducer from './paymentReducer';
import permsReducer from './permsReducer';
import sidebarReducer from './sidebarReducer';
import suraRolePermissionsReducer from './suraRolePermissionsReducer';
import suraSmsTemplateReducer from './suraSmsTemplateReducer';
import themeReducer from './themeReducer';
import topbarNotificationsReducer from './topbarNotificationsReducer';

export {
  accountReducer,
  adminReducer,
  agentReducer,
  agentsPaymentReducer,
  clientReducer,
  collectionReducer,
  contractReducer,
  customerReducer,
  detailsPanelReducer,
  domiciliationPermissionsReducer,
  errorsReducer,
  integrationsReducer,
  invoiceReducer,
  loginReducer,
  notificationsReducer,
  paymentAccountReducer,
  paymentReducer,
  permsReducer,
  sidebarReducer,
  suraRolePermissionsReducer,
  suraSmsTemplateReducer,
  themeReducer,
  topbarNotificationsReducer,
}



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js